var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Authenticate',{attrs:{"data-test-id":"AuthenticateComponent"}}),_c('FeedbackModal',{attrs:{"data-test-id":"FeedbackModalComponent"}}),_c('Version',{attrs:{"data-test-id":"VersionComponent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }